function Filters() {
  this.collectionProducts = [];
  this.pricings = [];
  this.sizes = [];
  this.collection_query = async () => {
    let collectionData = await Shopify.bundle_builder_data;
    let obj = {};
    let colLength = collectionData.length;

    for (let i = 0; i < colLength; i++) {
      let collection = collectionData[i];
      let res = await $.get(`/collections/${collection.handle}/products.json`);

      obj = {
        collection_handle: collection.handle,
        collection_id: collection.id,
        product_limit: collection.limit,
        isFree: collection.isFree,
        products: res.products,
      };
      this.collectionProducts.push(obj);
    }
  };
  this.filter_mapping = async () => {
    let collections = this.collectionProducts;
    let colLength = collections.length;
    for (let i = 0; i < colLength; i++) {
      let currProducts = collections[i].products;
      let colId = collections[i].collection_id;
      let prodLength = currProducts.length;
      for (let x = 0; x < prodLength; x++) {
        let currVar = currProducts[x].variants;
        let varLength = currVar.length;
        let prodId = currProducts[x].id;
        if (currProducts[x].options) {
          let currOption = currProducts[x].options;
          let opLength = currOption.length;
          for (let r = 0; r < opLength; r++) {
            if (currOption[r].name == "Size") {
              let opVal = currOption[r].values;
              let sizeObj = {
                collection_id: colId,
                product_id: prodId,
                values: opVal,
              };
              this.sizes.push(sizeObj);
            }
          }
        }
        for (let y = 0; y < varLength; y++) {
          if (currVar[y].price) {
            let varPrice = currVar[y].price;
            let priceObj = {
              collection_id: colId,
              product_id: prodId,
              price: varPrice,
            };
            this.pricings.push(priceObj);
          }
        }
      }
    }
    for (let i = 0; i < colLength; i++) {
      let tempProd = this.collectionProducts[i].products.map(
        (product, index) => {
          let prices = [];
          let pricingsLength = this.pricings.length;
          for (let y = 0; y < pricingsLength; y++) {
            let currPrice = this.pricings[y];
            if (
              currPrice.collection_id ==
                this.collectionProducts[i].collection_id &&
              currPrice.product_id == product.id
            ) {
              prices.push(Number(currPrice.price));
            }
          }
          let comparePrices = [];
          let varLength = product.variants.length;
          for (let x = 0; x < varLength; x++) {
            if (product.variants[x].compare_at_price) {
              comparePrices.push(product.variants[x].compare_at_price);
            }
          }
          if (comparePrices.length !== 0) {
            product.compare_price = Number(Math.max(...comparePrices));
          }
          product.max_price = Number(Math.max(...prices));
          product.min_price = Number(Math.min(...prices));
          product.order = index;
          return product;
        }
      );
      this.collectionProducts[i].products = tempProd;
    }
  };

  this.collectionFilterData = async () => {
    let values = this.collectionProducts.map((collection) => {
      let id = collection.collection_id;

      let valueArr = [];
      let count = 0;
      let sizesLength = this.sizes.length;
      for (let i = 0; i < sizesLength; i++) {
        let collectionObj = this.sizes[i];
        if (collectionObj.collection_id == id) {
          let colValLength = collectionObj.values.length;
          for (let x = 0; x < colValLength; x++) {
            valueArr.push(collectionObj.values[x]);
          }
        }
      }

      let priceMax = 0;
      let priceArr = [];

      let pricingsLength = this.pricings.length;
      for (let i = 0; i < pricingsLength; i++) {
        let currObj = this.pricings[i];
        if (currObj.collection_id == id) {
          priceArr.push(currObj.price);
        }
      }

      for (i = 0; i <= priceMax; i++) {
        if (priceArr[i] > priceMax) {
          priceMax = priceArr[i];
        }
      }

      const counts = {};
      valueArr.forEach(function (x) {
        counts[x] = (counts[x] || 0) + 1;
      });

      return {
        id,
        blocks_values: counts,
        priceMax,
        priceArr,
      };
    });

    console.log(values);

    return values;
  };

  this.formChanged = async (e) => {
    let collectionId = $(e.currentTarget.form).data("collection-id");
    let type = "filter";
    if (!collectionId) {
      collectionId = $(e.currentTarget).data("collection-id");
      type = "sort";
    }
    let sort = $(`input[name='sort_by-${collectionId}']:checked`).val();
    let data = $(`#bundle_filter_form-${collectionId}`).serializeArray();
    let formData = {
      collectionId,
      sort_by: "",
      sizes: [],
      price_from: 0,
      price_to: 0,
    };

    //console.log(data)

    let dataLength = data.length;

    for (let i = 0; i < dataLength; i++) {
      if (data[i].name == "sort_by") {
        formData.sort_by = sort;
      }
      if (data[i].name.includes("filter-v.option.size")) {
        formData.sizes.push(data[i].value);
      }
      if (data[i].name == "filter-v.price.gte") {
        formData.price_from = Number(data[i].value);
      }
      if (data[i].name == "filter-v.price.lte") {
        formData.price_to = Number(data[i].value);
      }
    }

    if (formData.sizes.length === 0) {
      this.filtered = [];
    }

    if (formData.sort_by === "manual") {
      this.sorted = [];
    }

    let collectionIndex = this.formData.findIndex(
      (obj) => obj.collectionId == collectionId
    );

    if (collectionIndex != -1) {
      this.formData[collectionIndex] = formData;
    } else {
      this.formData.push(formData);
    }

    if (type == "sort") {
      this.triggerSort();
    }
    if (type == "filter") {
      this.triggerFilter(collectionId);
    }

    this.applyChanges(collectionId);
  };

  this.formData = [];

  this.filtered = [];

  this.sorted = [];

  this.triggerFilter = (id) => {
    let price_from = 0;
    let price_to = 0;
    let formDataLength = this.formData.length;
    for (let i = 0; i < formDataLength; i++) {
      if (this.formData[i].collectionId == id) {
        price_from = this.formData[i].price_from;
        price_to = this.formData[i].price_to;
      }
    }

    let currCollection = [];
    if (this.sorted.length !== 0) {
      currCollection = this.sorted;
    } else {
      currCollection = this.collectionProducts;
    }

    let tempProducts = [];
    let currColLength = currCollection.length;
    for (let i = 0; i < currColLength; i++) {
      if (currCollection[i].collection_id == id) {
        tempProducts = currCollection[i].products;
      }
    }
    let currForm = this.formData.find((col) => col.collectionId == id);

    let mappedProducts = tempProducts.map((product) => {
      if (product) {
        let prodPriceMax = product.max_price;
        let prodPriceMin = product.min_price;
        if (product.options) {
          let optionBool = product.options.map((option) => {
            if (option.name == "Size" && currForm.sizes.length !== 0) {
              let contains = currForm.sizes.every((val) => {
                return option.values.includes(val);
              });
              return contains;
            }
            if (currForm.sizes.length === 0) {
              return true;
            }
          });
          if (optionBool.indexOf(true) != -1) {
            // console.log('Product Min:', prodPriceMin);
            // console.log('Product Max:', prodPriceMax);
            // console.log('Form Min:', price_from);
            // console.log('Form Max', price_to)
            if (prodPriceMin >= price_from && prodPriceMax <= price_to) {
              return product;
            }
          }
        }
      }
    });

    // for(let i = 0; i < currCollection.length; i++){
    //     if(currCollection[i].collection_id == id){
    //         let collectionIndex = this.filtered.findIndex((obj => obj.collection_id == currCollection[i].collection_id));
    //         let newObj = currCollection[i];
    //         if(collectionIndex != -1){
    //             newObj.products =  mappedProducts;
    //             this.filtered[collectionIndex] = newObj;
    //         }else{
    //             newObj.products =  mappedProducts;
    //             this.filtered.push(newObj);
    //         }
    //     }
    // }

    let newObj = {
      collection_id: id,
      products: mappedProducts,
    };
    let collectionIndex = this.filtered.findIndex(
      (obj) => obj.collection_id == id
    );
    if (collectionIndex != -1) {
      this.filtered[collectionIndex] = newObj;
    } else {
      this.filtered.push(newObj);
    }

    // console.log(this.filtered)
  };

  this.triggerSort = async () => {
    let collectionArr = [];
    if (this.filtered.length !== 0) {
      collectionArr = this.filtered;
    } else {
      collectionArr = this.collectionProducts;
    }

    let colArrLength = collectionArr.length;
    let formDataLength = this.formData.length;
    for (let i = 0; i < colArrLength; i++) {
      for (let x = 0; x < formDataLength; x++) {
        if (collectionArr[i]) {
          if (collectionArr[i].collection_id == this.formData[x].collectionId) {
            let products = collectionArr[i].products;
            let collection = collectionArr[i];
            if (this.formData[x].sort_by == "created-ascending") {
              let sort = products
                .slice()
                .sort(
                  (a, b) => new Date(b.published_at) - new Date(a.published_at)
                );
              collection.products = sort;
              let newObj = collection;
              let collectionIndex = this.sorted.findIndex(
                (obj) => obj.collection_id == collection.collection_id
              );
              if (collectionIndex != -1) {
                this.sorted[collectionIndex] = newObj;
              } else {
                this.sorted.push(newObj);
              }
            }
            if (this.formData[x].sort_by == "created-descending") {
              let sort = products
                .slice()
                .sort(
                  (a, b) => new Date(a.published_at) - new Date(b.published_at)
                );
              collection.products = sort;
              let newObj = collection;
              let collectionIndex = this.sorted.findIndex(
                (obj) => obj.collection_id == collection.collection_id
              );
              if (collectionIndex != -1) {
                this.sorted[collectionIndex] = newObj;
              } else {
                this.sorted.push(newObj);
              }
            }
            if (this.formData[x].sort_by == "price-ascending") {
              let sort = products
                .slice()
                .sort((a, b) => a.max_price - b.max_price);
              collection.products = sort;
              let newObj = collection;
              let collectionIndex = this.sorted.findIndex(
                (obj) => obj.collection_id == collection.collection_id
              );
              if (collectionIndex != -1) {
                this.sorted[collectionIndex] = newObj;
              } else {
                this.sorted.push(newObj);
              }
            }
            if (this.formData[x].sort_by == "price-descending") {
              let sort = products
                .slice()
                .sort((a, b) => b.max_price - a.max_price);
              collection.products = sort;
              let newObj = collection;
              let collectionIndex = this.sorted.findIndex(
                (obj) => obj.collection_id == collection.collection_id
              );
              if (collectionIndex != -1) {
                this.sorted[collectionIndex] = newObj;
              } else {
                this.sorted.push(newObj);
              }
            }
            if (this.formData[x].sort_by == "title-ascending") {
              let sort = products
                .slice()
                .sort((a, b) => ("" + a.title).localeCompare(b.title));
              collection.products = sort;
              let newObj = collection;
              let collectionIndex = this.sorted.findIndex(
                (obj) => obj.collection_id == collection.collection_id
              );
              if (collectionIndex != -1) {
                this.sorted[collectionIndex] = newObj;
              } else {
                this.sorted.push(newObj);
              }
            }
            if (this.formData[x].sort_by == "title-descending") {
              let sort = products
                .slice()
                .sort((a, b) => ("" + b.title).localeCompare(a.title));
              collection.products = sort;
              let newObj = collection;
              let collectionIndex = this.sorted.findIndex(
                (obj) => obj.collection_id == collection.collection_id
              );
              if (collectionIndex != -1) {
                this.sorted[collectionIndex] = newObj;
              } else {
                this.sorted.push(newObj);
              }
            }
            if (this.formData[x].sort_by == "manual") {
              let newObj = collection;
              let collectionIndex = this.sorted.findIndex(
                (obj) => obj.collection_id == collection.collection_id
              );
              if (collectionIndex != -1) {
                this.sorted[collectionIndex] = newObj;
              } else {
                this.sorted.push(newObj);
              }
            }
          }
        }
      }
    }
  };

  this.template = (
    collection_id,
    product_id,
    product_handle,
    media_id,
    img_height,
    secondary_img_height,
    img_width,
    secondary_img_width,
    product_title,
    img_src,
    secondary_img_src,
    product_price,
    product_compare_price
  ) => {
    return String(`<product-item class="product-item " reveal="" style="opacity: 1;">
        <div class="product-item__image-wrapper product-item__image-wrapper--multiple">
        <a href="/products/${product_handle}" class="product-item__aspect-ratio aspect-ratio " style="padding-bottom: 150.0%; --aspect-ratio: 0.6666666666666666">
            <img class="product-item__primary-image" loading="lazy" data-media-id="${media_id}" sizes="(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 305px) / 3 - 16px)" height="${img_height}" width="${img_width}" alt="${product_title}" src="${img_src}" >
            <img class="product-item__secondary-image" loading="lazy" sizes="(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 305px) / 3 - 16px)"  height="${secondary_img_height}" width="${secondary_img_width}" alt="${product_title}" src="${secondary_img_src}" >
        </a>
        </div>
        <div class="product-item__info  ">
            <div class="product-item-meta"><a href="/products/${product_handle}" class="product-item-meta__title">${product_title}</a>
                <div class="product-item-meta__price-list-container">
                    <div class="price-list price-list--centered">
                    <span class="price ${
                      product_compare_price != 0 ? "price--highlight" : ""
                    }">
                        <span class="visually-hidden">Sale price</span>$ ${product_price}
                        </span>
                        ${
                          product_compare_price != 0
                            ? `<span class="price price--compare">
                        <span class="visually-hidden">Regular price</span>$ ${product_compare_price}</span>`
                            : ""
                        }
                        
                        </div>
                </div>
                <div class="product_btn_container">
            <button data-selected="false"  data-product-id="${product_id}" data-collection-id="${collection_id}" aria-popup="bundle-popover" class="bundle-add-btn button button--bundle button--outline button--text button--full ">
                <span class="loader-button__text">ADD TO BUNDLE</span>
                <span class="loader-button__loader" hidden="">
                <div class="spinner">
                    <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                    </svg>
                </div>
                </span>
            </button>
        </div>
            </div>
        </div>
  </product-item>`);
  };

  this.applyChanges = async (id) => {
    console.log("APPLYING");
    let collectionArr = [];
    if (this.sorted.length !== 0 && this.filtered.length === 0) {
      collectionArr = this.sorted;
      //console.log('SORTED');
    }
    if (this.sorted.length !== 0 && this.filtered.length !== 0) {
      collectionArr = this.sorted;
      //console.log('SORTED & FILTERED');
    }
    if (this.sorted.length === 0 && this.filtered.length === 0) {
      collectionArr = this.collectionProducts;
      //console.log('DEFAULT');
    }
    if (this.sorted.length === 0 && this.filtered.length !== 0) {
      collectionArr = this.filtered;
      //console.log('FILTERED');
    }

    let html = "";
    let colArrLength = collectionArr.length;
    for (let i = 0; i < colArrLength; i++) {
      if (collectionArr[i].collection_id == id) {
        collectionArr[i].products.forEach((product) => {
          if (product) {
            let product_id = product.id;
            let product_handle = product.handle;
            let media_id = product.images[0].id;
            let img_height = product.images[0].height;
            let img_width = product.images[0].width;
            let img_src = product.images[0].src;
            let secondary_img_height = product.images[1].height;
            let secondary_img_width = product.images[1].width;
            let secondary_img_src = product.images[1].src;
            let product_title = product.title;
            let product_price = product.max_price;
            let product_compare_price = product.compare_price || 0;
            html += this.template(
              id,
              product_id,
              product_handle,
              media_id,
              img_height,
              secondary_img_height,
              img_width,
              secondary_img_width,
              product_title,
              img_src,
              secondary_img_src,
              product_price,
              product_compare_price
            );
          }
        });
        $(`#inner_product_container-${id}`).html(html);
      }
    }
  };

  this.bundleStorage = [];

  this.productDataForm = async (e) => {
    if ($(e.currentTarget).attr("data-selected") === "true") {
      let loaderText = $(e.currentTarget).children(".loader-button__text")[0];
      let collectionId = $(e.currentTarget).data("collection-id");
      let productId = $(e.currentTarget).data("product-id");
      let productBtn = e.currentTarget;
      $(`#product-count-${collectionId}`).html(
        parseInt($(`#product-count-${collectionId}`).html()) - 1
      );
      let count = parseInt($(`#product-count-${collectionId}`).text());
      let limit = $(`tab[data-collection-id='${collectionId}']`).data("limit");
      $(loaderText).text("Add to bundle");
      let btnLength = $(`button[data-collection-id="${collectionId}"]`).length;
      for (let i = 0; i < btnLength; i++) {
        let addBtn = $(`button[data-collection-id="${collectionId}"]`)[i];
        if (
          $(addBtn).data("product-id") != $(productBtn).data("product-id") &&
          $(addBtn).data("selected") != true
        ) {
          $(addBtn).removeAttr("disabled", "");
          $(addBtn).removeClass("button--ternary");
          $(addBtn).addClass("button--bundle");
        }
      }
      $(productBtn).attr("data-selected", "false");
      if (count != limit) {
        $(`tab[data-collection-id='${collectionId}']`).removeClass("complete");
      }
      let productIndex = this.bundleStorage.findIndex(
        (obj) => obj.product_id == productId
      );
      if (productIndex != -1) {
        this.bundleStorage.splice(productIndex, 1);
      }

      $("#submit_bundle").addClass("button--ternary");
      $("#submit_bundle").removeClass("button--bundle");
      $("#submit_bundle").attr("disabled", "");
      $("#bundle-storage-submit").addClass("button--ternary");
      $("#bundle-storage-submit").removeClass("button--bundle");
      $("#bundle-storage-submit").attr("disabled", "");
    } else {
      if ($(e.currentTarget).attr("disabled") != "disabled") {
        let productId = $(e.currentTarget).data("product-id");
        let collectionId = $(e.currentTarget).data("collection-id");
        let collectionData = this.collectionProducts.find(
          (collection) => collection.collection_id == collectionId
        );
        let productData = collectionData.products.find(
          (product) => product.id == productId
        );
        let oneVariant = false;
        if (
          productData.variants.length >= 1 &&
          productData.variants[0].title == "Default Title"
        ) {
          oneVariant = true;
        }
        let productObj = {
          product_handle: productData.handle,
          product_id: productId,
          product_desc: productData.body_html,
          product_image: productData.images[0],
          product_title: productData.title,
          product_max_price: productData.max_price,
          variant_data: productData.variants,
        };

        let imageHtml = `<a href="/products/${productObj.product_handle}" class="product-item__aspect-ratio aspect-ratio " style="padding-bottom: 150.0%; --aspect-ratio: 0.6666666666666666">
                <img class="product-item__primary-image" loading="lazy" data-media-id="${productObj.product_image.id}" sizes="(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 305px) / 3 - 16px)" height="${productObj.product_image.height}" width="${productObj.product_image.width}" alt="${productObj.product_title}" src="${productObj.product_image.src}" >
            </a>`;

        $("#bundle-product-image-container").html(imageHtml);

        let html = "";
        $("#bundle-product-title").text(productObj.product_title);
        $($("#bundle-product-details a")[0]).attr(
          "href",
          `/products/${productObj.product_handle}`
        );
        //$("#bundle-product-description").html(productObj.product_desc)
        $("#product-price").text(`$${productObj.product_max_price}`);

        productObj.variant_data.forEach((variant) => {
          let template = `<div class="block-swatch ${
            variant.available ? "" : "is-disabled"
          }">
                    <input value="${variant.id}" data-product-id="${
            productObj.product_id
          }" data-variant-price="${
            variant.price
          }"  class="block-swatch__radio visually-hidden" type="radio" name="bundle-input">
                    <label class="block-swatch__item">${variant.title}</label>
                </div>`;
          html += template;
        });
        $("#bundle-product-variants").html(html);
        if (oneVariant) {
          this.addOneVariant(
            productObj.variant_data[0].id,
            productId,
            collectionId,
            productObj.product_max_price
          );
        } else {
          $("#bundle-popover").addClass("visible-form");
          $("#bundle-container").addClass("visible-form");
        }
      }
    }
  };

  this.addOneVariant = async (variantId, productId, collectionId, price) => {
    let totalLimit = this.collectionProducts.reduce((acc, col) => {
      return acc + col.product_limit;
    }, 0);
    let productBtn = $(`button[data-product-id="${productId}"]`)[0];
    $($(productBtn).children(".loader-button__text")[0]).text(
      "Remove from Bundle"
    );
    $(productBtn).attr("data-selected", "true");
    $(productBtn).attr("aria-hidden", "true");
    $(`#product-count-${collectionId}`).html(
      parseInt($(`#product-count-${collectionId}`).html()) + 1
    );
    let count = parseInt($(`#product-count-${collectionId}`).text());
    let limit = $(`tab[data-collection-id='${collectionId}']`).data("limit");
    let data = {
      collection_id: collectionId,
      variant_id: variantId,
      product_id: productId,
      price: price,
    };
    if (limit == count) {
      for (
        let i = 0;
        i < $(`button[data-collection-id="${collectionId}"]`).length;
        i++
      ) {
        let addBtn = $(`button[data-collection-id="${collectionId}"]`)[i];
        if (
          $(addBtn).data("product-id") != $(productBtn).data("product-id") &&
          $(addBtn).data("selected") != true
        ) {
          $(addBtn).attr("disabled", "");
          $(addBtn).removeClass("button--bundle");
          $(addBtn).addClass("button--ternary");
        }
      }
      $(`tab[data-collection-id='${collectionId}']`).addClass("complete");
      $(`tab[data-collection-id='${collectionId}']`).next().click();
    }

    this.bundleStorage.push(data);
    if (this.bundleStorage.length === totalLimit) {
      this.bundleComplete();
    } else {
      this.addItemBundle();
      const aTag = $("#bundle_anchor");
      $("html,body").animate({ scrollTop: aTag.offset().top }, "slow");
    }
  };

  this.variantClick = async (e) => {
    let totalLimit = this.collectionProducts.reduce((acc, col) => {
      return acc + col.product_limit;
    }, 0);

    let currInput = $(e.currentTarget).children("input")[0];
    let variantId = $(currInput).val();
    let currLabel = $(e.currentTarget).children("label")[0];
    let productId = $(currInput).data("product-id");
    let price = $(currInput).data("variant-price");
    let productBtn = $(`button[data-product-id="${productId}"]`)[0];
    let collectionId = $(productBtn).data("collection-id");
    let bundleInputLength = $("input[name='bundle-input']").length;
    for (let i = 0; i < bundleInputLength; i++) {
      let input = $("input[name='bundle-input']")[i];
      $(input).prop("checked", false);
    }
    $(currInput).prop("checked", true);
    $("#bundle-popover").removeClass("visible-form");
    $("#bundle-container").removeClass("visible-form");
    $($(productBtn).children(".loader-button__text")[0]).text(
      "Remove from Bundle"
    );
    $(productBtn).attr("data-selected", "true");
    $(`#product-count-${collectionId}`).html(
      parseInt($(`#product-count-${collectionId}`).html()) + 1
    );
    let count = parseInt($(`#product-count-${collectionId}`).text());
    let limit = $(`tab[data-collection-id='${collectionId}']`).data("limit");
    let data = {
      collection_id: collectionId,
      variant_id: variantId,
      product_id: productId,
      price: price,
    };
    if (limit == count) {
      for (
        let i = 0;
        i < $(`button[data-collection-id="${collectionId}"]`).length;
        i++
      ) {
        let addBtn = $(`button[data-collection-id="${collectionId}"]`)[i];
        if (
          $(addBtn).data("product-id") != $(productBtn).data("product-id") &&
          $(addBtn).data("selected") != true
        ) {
          $(addBtn).attr("disabled", "");
          $(addBtn).removeClass("button--bundle");
          $(addBtn).addClass("button--ternary");
        }
      }
      $(`tab[data-collection-id='${collectionId}']`).addClass("complete");
      $(`tab[data-collection-id='${collectionId}']`).next().click();
    }

    this.bundleStorage.push(data);
    if (this.bundleStorage.length === totalLimit) {
      this.bundleComplete();
    } else {
      this.addItemBundle();
      const aTag = $("#bundle_anchor");
      $("html,body").animate({ scrollTop: aTag.offset().top }, "slow");
    }
  };

  this.productAddedTemplate = (
    featured_image,
    product_title,
    variant_compare_price,
    variant_sale_price,
    product_id,
    collection_id,
    product_handle
  ) => {
    let isFree = false;
    this.collectionProducts.forEach((collection) => {
      if (collection_id == collection.collection_id && collection.isFree) {
        isFree = true;
      }
    });
    let template = `<div class="bundle-added-item" data-product-id="${product_id}", data-collection-id="${collection_id}" >
            <div class="bundle-added-image-container">
                <a href="/products/${product_handle}" class="product-item__aspect-ratio aspect-ratio " style="padding-bottom: 150.0%; --aspect-ratio: 0.6666666666666666">
                <img class="product-item__primary-image" loading="lazy" data-media-id="${
                  featured_image.id
                }" sizes="(max-width: 740px) calc(50vw - 24px), calc((min(100vw - 80px, 1520px) - 305px) / 3 - 16px)" height="${
      featured_image.height
    }" width="${featured_image.width}" alt="${product_title}" src="${
      featured_image.src
    }" >
                </a>
            </div>
            <div class="bundle-added-meta">
                <h6>${product_title}</h6>
                <div class="bundle-added-pricing">
                    <p class="b-a-price">${
                      isFree
                        ? `<strong>Free Gift! </strong><span class="bundle-added-compare">${variant_sale_price}</span>`
                        : `${variant_sale_price} ${
                            variant_compare_price != null
                              ? `<span class="bundle-added-compare">${variant_compare_price}</span>`
                              : ""
                          }`
                    }</p>
                    <span class="bundle-added-remove" data-product-id="${product_id}" data-collection-id="${collection_id}">Remove</span>
                </div>
            </div>
        </div>`;

    return template;
  };

  this.bundleDiscountTier = async (total_price) => {
    let discount = 20;
    return total_price - (total_price * discount) / 100;
  };

  this.bundleComplete = async () => {
    const salePriceEl = $(".b-sale-price")[0];
    const comparePriceEl = $(".b-pricing-compare")[0];
    const originalPrice = $("#bundle_anchor").data("pricing");
    const discountQuantity = $("#bundle_anchor").data("discount-qty");
    const salePrice = $("#bundle_anchor").data("compare-price");
    const discountType = $("#bundle_anchor").data("discount-type");
    const totalPrice = this.bundleStorage.reduce((sum, variant) => {
      for (let i = 0; i < this.collectionProducts.length; i++) {
        if (
          variant.collection_id == this.collectionProducts[i].collection_id &&
          this.collectionProducts[i].isFree
        ) {
          return sum;
        }
      }
      return sum + parseFloat(variant.price);
    }, 0);
    if (discountType == "fixed") {
      if (originalPrice != salePrice) {
        $(salePriceEl).text(`${salePrice}`);
        $(comparePriceEl).text(`${originalPrice}`);
      } else {
        $(salePriceEl).text(`${salePrice}`);
      }
    }

    if (discountType == "fixed-product") {
      if (discountQuantity > 0) {
        $(comparePriceEl).text(`$${totalPrice}`);
        $(salePriceEl).text(`$${totalPrice - discountQuantity}`);
      } else {
        $(salePriceEl).text(`$${totalPrice}`);
      }
    }

    if (discountType == "percentage-product") {
      if (discountQuantity > 0) {
        $(comparePriceEl).text(`$${totalPrice}`);
        $(salePriceEl).text(
          `$${totalPrice - totalPrice * (discountQuantity / 100)}`
        );
      } else {
        $(salePriceEl).text(`$${totalPrice}`);
      }
    }

    if (discountType == "free-product") {
      $(salePriceEl).text(`$${totalPrice} + Free Gift`);
    }
    $("#bundle-popover").addClass("visible-form");
    $("#bundle-storage-container").addClass("visible-form");
    $("#submit_bundle").removeClass("button--ternary");
    $("#submit_bundle").addClass("button--bundle");
    $("#submit_bundle").removeAttr("disabled");
    $("#bundle-storage-submit").removeClass("button--ternary");
    $("#bundle-storage-submit").addClass("button--bundle");
    $("#bundle-storage-submit").removeAttr("disabled", "");
    let html = "";
    // let totalPrice = 0;
    let bundleStorageLength = this.bundleStorage.length;
    for (let i = 0; i < bundleStorageLength; i++) {
      let currObj = this.bundleStorage[i];
      let collectionData = this.collectionProducts.find(
        (collection) => collection.collection_id == currObj.collection_id
      );
      let productData = collectionData.products.find(
        (product) => product.id == currObj.product_id
      );
      let variantData = productData.variants.find(
        (variant) => variant.id == currObj.variant_id
      );
      html += this.productAddedTemplate(
        productData.images[0],
        productData.title,
        variantData.compare_at_price,
        variantData.price,
        productData.id,
        collectionData.collection_id,
        productData.handle
      );
      // totalPrice += Number(variantData.price);
    }
    // let discountPrice = await this.bundleDiscountTier(totalPrice);

    $("#bundle-storage-content").html(html);
  };

  this.addItemBundle = async () => {
    let html = "";
    // let totalPrice = 0;
    let bundleStorageLength = this.bundleStorage.length;
    for (let i = 0; i < bundleStorageLength; i++) {
      let currObj = this.bundleStorage[i];
      let collectionData = this.collectionProducts.find(
        (collection) => collection.collection_id == currObj.collection_id
      );
      let productData = collectionData.products.find(
        (product) => product.id == currObj.product_id
      );
      let variantData = productData.variants.find(
        (variant) => variant.id == currObj.variant_id
      );
      html += this.productAddedTemplate(
        productData.images[0],
        productData.title,
        variantData.compare_at_price,
        variantData.price,
        productData.id,
        collectionData.collection_id,
        productData.handle
      );
      // totalPrice += Number(variantData.price);
    }
    // let discountPrice = await this.bundleDiscountTier(totalPrice);
    $("#bundle-storage-content").html(html);
  };

  this.removeAll = async () => {
    $("#submit_bundle").addClass("button--ternary");
    $("#submit_bundle").removeClass("button--bundle");
    $("#submit_bundle").attr("disabled", "");
    $("#bundle-storage-submit").addClass("button--ternary");
    $("#bundle-storage-submit").removeClass("button--bundle");
    $("#bundle-storage-submit").attr("disabled", "");
    this.bundleStorage.forEach((col) => {
      let productId = col.product_id;
      let collectionId = col.collection_id;
      $(`tab[data-collection-id='${collectionId}']`).removeClass("complete");
      $(`#product-count-${collectionId}`).text("0");
      let currElement = $(
        `button[data-selected='true'][data-product-id='${productId}'][data-collection-id='${collectionId}']`
      )[0];
      let loaderText = $(currElement).children(".loader-button__text")[0];
      $(loaderText).text("Add to bundle");
      let btnLength = $(`button[data-collection-id="${collectionId}"]`).length;
      for (let x = 0; x < btnLength; x++) {
        let addBtn = $(`button[data-collection-id="${collectionId}"]`)[x];
        if ($(addBtn).data("product-id") != productId) {
          $(addBtn).removeAttr("disabled", "");
          $(addBtn).removeClass("button--ternary");
          $(addBtn).addClass("button--bundle");
        }
      }
      $(currElement).attr("data-selected", "false");
    });
    this.bundleStorage = [];
    $("#bundle-popover").removeClass("visible-form");
    $("#bundle-storage-container").removeClass("visible-form");
  };

  this.removeItem = async (e) => {
    $("#submit_bundle").addClass("button--ternary");
    $("#submit_bundle").removeClass("button--bundle");
    $("#submit_bundle").attr("disabled", "");
    $("#bundle-storage-submit").addClass("button--ternary");
    $("#bundle-storage-submit").removeClass("button--bundle");
    $("#bundle-storage-submit").attr("disabled", "");
    let productId = $(e.currentTarget).data("product-id");
    let collectionId = $(e.currentTarget).data("collection-id");
    let productBtn = $(
      `button[data-selected='true'][data-product-id='${productId}'][data-collection-id='${collectionId}']`
    )[0];
    let loaderText = $(productBtn).children(".loader-button__text")[0];
    $(`#product-count-${collectionId}`).html(
      parseInt($(`#product-count-${collectionId}`).html()) - 1
    );
    let count = parseInt($(`#product-count-${collectionId}`).text());
    let limit = $(`tab[data-collection-id='${collectionId}']`).data("limit");
    $(
      $(
        `.bundle-added-item[data-product-id='${productId}'][data-collection-id='${collectionId}']`
      )[0]
    ).remove();
    $(loaderText).text("Add to bundle");
    let btnLength = $(`button[data-collection-id="${collectionId}"]`).length;
    for (let i = 0; i < btnLength; i++) {
      let addBtn = $(`button[data-collection-id="${collectionId}"]`)[i];
      if (
        $(addBtn).data("product-id") != $(productBtn).data("product-id") &&
        $(addBtn).data("selected") != true
      ) {
        $(addBtn).removeAttr("disabled", "");
        $(addBtn).removeClass("button--ternary");
        $(addBtn).addClass("button--bundle");
      }
    }
    $(productBtn).attr("data-selected", "false");
    if (count != limit) {
      $(`tab[data-collection-id='${collectionId}']`).removeClass("complete");
    }
    let productIndex = this.bundleStorage.findIndex(
      (obj) => obj.product_id == productId
    );
    if (productIndex != -1) {
      this.bundleStorage.splice(productIndex, 1);
    }

    const salePriceEl = $(".b-sale-price")[0];
    const comparePriceEl = $(".b-pricing-compare")[0];
    const originalPrice = $("#bundle_anchor").data("pricing");
    const discountQuantity = $("#bundle_anchor").data("discount-qty");
    const salePrice = $("#bundle_anchor").data("compare-price");
    const discountType = $("#bundle_anchor").data("discount-type");
    const totalPrice = this.bundleStorage.reduce((sum, variant) => {
      for (let i = 0; i < this.collectionProducts.length; i++) {
        if (
          variant.collection_id == this.collectionProducts[i].collection_id &&
          this.collectionProducts[i].isFree
        ) {
          return sum;
        }
      }
      return sum + parseFloat(variant.price);
    }, 0);
    if (discountType == "fixed") {
      if (originalPrice != salePrice) {
        $(salePriceEl).text(`${salePrice}`);
        $(comparePriceEl).text(`${originalPrice}`);
      } else {
        $(salePriceEl).text(`${salePrice}`);
      }
    }

    if (discountType == "fixed-product") {
      if (discountQuantity > 0) {
        $(comparePriceEl).text(`$${totalPrice}`);
        $(salePriceEl).text(`$${totalPrice - discountQuantity}`);
      } else {
        $(salePriceEl).text(`$${totalPrice}`);
      }
    }

    if (discountType == "percentage-product") {
      if (discountQuantity > 0) {
        $(comparePriceEl).text(`$${totalPrice}`);
        $(salePriceEl).text(
          `$${totalPrice - totalPrice * (discountQuantity / 100)}`
        );
      } else {
        $(salePriceEl).text(`$${totalPrice}`);
      }
    }

    if (discountType == "free-product") {
      $(salePriceEl).text(`$${totalPrice} + Free Gift`);
    }
    // console.log(this.bundleStorage)
  };

  this.ajaxToCart = async () => {
    let totalLimit = this.collectionProducts.reduce((acc, col) => {
      return acc + col.product_limit;
    }, 0);

    if (this.bundleStorage.length === totalLimit) {
      let items = [];
      let bundleHandle = $("#bundle_anchor").data("bundle-handle");
      let pricing = $("#bundle_anchor").data("pricing-property");
      let discountQuantity = $("#bundle_anchor").data("discount-qty");
      let discountType = $("#bundle_anchor").data("discount-type");
      let productTotal = $("#bundle_anchor").data("total-limit");
      let discountLimit = $("#bundle_anchor").data("discount-limit");
      let totalPrice = this.bundleStorage.reduce((acc, col) => {
        return acc + Number(col.price);
      }, 0);
      this.bundleStorage.forEach((col) => {
        let isFree = false;
        this.collectionProducts.forEach((collection) => {
          if (
            collection.collection_id === col.collection_id &&
            collection.isFree
          ) {
            isFree = true;
          }
        });
        let data = {
          id: Number(col.variant_id),
          quantity: 1,
          properties: {},
        };
        if (isFree) {
          data.properties["_freeText"] = $("#bundle_anchor").data("free-text");
        }
        data.properties["_bundle"] = true;
        data.properties["_isFree"] = isFree;
        data.properties["_bundleHandle"] = bundleHandle;
        data.properties["_pricing"] = pricing;
        data.properties["_discountType"] = discountType;
        data.properties["_discountQuantity"] = discountQuantity;
        data.properties["_productTotal"] = productTotal;
        data.properties["_totalPrice"] = totalPrice;
        data.properties["_discountLimit"] = discountLimit;
        items.push(data);
      });
      console.log(items);
      let data = {
        items: items,
      };
      fetch("/cart/add.js", {
        body: JSON.stringify(data),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
      })
        .then((res) => res.json())
        .then(() => {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );
          document.getElementById("mini-cart").open = true;
        });
      this.removeAll();
    }
  };
}

const bundleBuilder = async () => {
  let activeCol = $("tab.active")[0];
  let currId = $(activeCol).data("collection-id");
  let mobileFilter = $("button.mobile-toolbar__item--filters")[0];
  let mobileSort = $("button.mobile-toolbar__item--sort")[0];
  $(mobileFilter).attr("aria-controls", `facet-filters-${currId}`);
  $(mobileSort).attr("aria-controls", `sort-by-popover-${currId}`);
  $(".bundle_tabs_container tab").on("click", function (e) {
    let collectionId = e.currentTarget.dataset.collectionId;
    let wrapper = $(".bundle_builder_wrapper");
    let bundleTabLength = $(".bundle_tabs_container tab").length;
    $(mobileFilter).attr("aria-controls", `facet-filters-${collectionId}`);
    $(mobileSort).attr("aria-controls", `sort-by-popover-${collectionId}`);
    for (let i = 0; i < bundleTabLength; i++) {
      let curr = $(".bundle_tabs_container tab")[i];
      if ($(curr).data("collection-id") == collectionId) {
        $(curr).addClass("active");
      } else {
        $(curr).removeClass("active");
      }
    }
    let wrapperLength = wrapper.length;
    for (let i = 0; i < wrapperLength; i++) {
      if ($(wrapper[i]).attr("id") == `container-${collectionId}`) {
        $(wrapper[i]).addClass("active");
      } else {
        $(wrapper[i]).removeClass("active");
      }
    }
  });

  let tabs = $(".bundle_tabs_container tab");
  Shopify.bundle_builder_data = [];
  for (let i = 0; i < tabs.length; i++) {
    let tab = tabs[i];
    let handle = $(tab).data("collection-handle");
    let id = $(tab).data("collection-id");
    let limit = $(tab).data("limit");
    let isFree = false;
    if (
      $(tab).data("is-free") == true &&
      $("#bundle_anchor").data("discount-type") == "free-product"
    ) {
      isFree = true;
    }
    let obj = {
      handle,
      id,
      limit,
      isFree,
    };

    Shopify.bundle_builder_data.push(obj);
  }
  const bundleFilter = new Filters();
  await bundleFilter.collection_query();
  await bundleFilter.filter_mapping();
  let blockData = await bundleFilter.collectionFilterData();
  console.log(bundleFilter.collectionProducts);
  // console.log("PRICES",bundleFilter.pricings)
  blockData.forEach((block) => {
    let id = block.id;
    let appendHtml = "";
    for (let key in block.blocks_values) {
      let html = `<div class="block-swatch ">
                <input class="block-swatch__radio visually-hidden" type="checkbox" name="filter-v.option.size-${id}" id="filter.v.option.size-${id}-${key}" value="${key}">
                <label class="block-swatch__item" for="filter.v.option.size-${id}-${key}">${key}</label>
              </div>`;
      appendHtml += html;
    }
    $(`#size_block_swatch-${id}`).append(appendHtml);
    document
      .getElementById(`filter.v.price.gte-${id}`)
      .setAttribute("max", block.priceMax);
    document
      .getElementById(`filter.v.price.lte-${id}`)
      .setAttribute("max", block.priceMax);
    document.getElementById(`filter.v.price.lte-${id}`).value = block.priceMax;
    document
      .getElementById(`price-range-from-${id}`)
      .setAttribute("max", block.priceMax);
    document
      .getElementById(`price-range-to-${id}`)
      .setAttribute("max", block.priceMax);
    document.getElementById(`price-range-to-${id}`).value = block.priceMax;
    $(`#bundle_filter_form-${id} input`).on("change", bundleFilter.formChanged);
    $(`input[name='sort_by-${id}']`).on("change", bundleFilter.formChanged);
  });

  $(document).on("click", ".bundle-add-btn", (e) => {
    bundleFilter.productDataForm(e);
  });

  let propVar;

  $(document).on("click", ".block-swatch__radio", function (e) {
    // in the handler, 'this' refers to the box clicked on
    var $box = $(e.currentTarget);
    if ($box.is(":checked")) {
      // the name of the box is retrieved using the .attr() method
      // as it is assumed and expected to be immutable
      var group = "input:checkbox[name='" + $box.attr("name") + "']";
      // the checked state of the group/box on the other hand will change
      // and the current value is retrieved using .prop() method
      $(group).prop("checked", false);
      $box.prop("checked", true);
    } else {
      $box.prop("checked", false);
    }
  });

  $("#bundle-close").on("click", () => {
    $("#bundle-popover").removeClass("visible-form");
    $("#bundle-container").removeClass("visible-form");
  });

  $("#bundle-storage-close").on("click", () => {
    $("#bundle-popover").removeClass("visible-form");
    $("#bundle-storage-container").removeClass("visible-form");
  });

  $("#bundle-product-variants").on(
    "click",
    ".block-swatch",
    bundleFilter.variantClick
  );

  $("#bundle-storage-content ").on(
    "click",
    ".bundle-added-remove",
    bundleFilter.removeItem
  );

  window.onbeforeunload = function () {
    if (bundleFilter.bundleStorage.length !== 0) {
      return "Leaving the page will not save any changes in the Bundle Builder";
    } else {
      return;
    }
  };

  $(".bundle-storage-btn").on("click", () => {
    bundleFilter.ajaxToCart();
    $("#bundle-popover").removeClass("visible-form");
    $("#bundle-storage-container").removeClass("visible-form");
  });

  const salePriceEl = $(".b-sale-price")[0];
  const comparePriceEl = $(".b-pricing-compare")[0];
  const originalPrice = $("#bundle_anchor").data("pricing");
  const discountQuantity = $("#bundle_anchor").data("discount-qty");
  const salePrice = $("#bundle_anchor").data("compare-price");
  const discountType = $("#bundle_anchor").data("discount-type");

  $("#preview_bundle_btn").on("click", () => {
    if (discountType == "fixed") {
      if (originalPrice != salePrice) {
        $(salePriceEl).text(`${salePrice}`);
        $(comparePriceEl).text(`${originalPrice}`);
      } else {
        $(salePriceEl).text(`${salePrice}`);
      }
    }

    if (discountType == "fixed-product") {
      const totalPrice = bundleFilter.bundleStorage.reduce((sum, variant) => {
        return sum + parseFloat(variant.price);
      }, 0);
      if (discountQuantity > 0) {
        $(comparePriceEl).text(`$${totalPrice}`);
        $(salePriceEl).text(`$${totalPrice - discountQuantity}`);
      } else {
        $(salePriceEl).text(`$${totalPrice}`);
      }
    }

    if (discountType == "percentage-product") {
      const totalPrice = bundleFilter.bundleStorage.reduce((sum, variant) => {
        return sum + parseFloat(variant.price);
      }, 0);
      if (discountQuantity > 0) {
        $(comparePriceEl).text(`$${totalPrice}`);
        $(salePriceEl).text(
          `$${totalPrice - totalPrice * (discountQuantity / 100)}`
        );
      } else {
        $(salePriceEl).text(`$${totalPrice}`);
      }
    }

    if (discountType == "free-product") {
      const totalPrice = bundleFilter.bundleStorage.reduce((sum, variant) => {
        for (let i = 0; i < this.collectionProducts.length; i++) {
          if (
            variant.collection_id ==
              bundleFilter.collectionProducts[i].collection_id &&
            bundleFilter.collectionProducts[i].isFree
          ) {
            return sum;
          }
        }
        return sum + parseFloat(variant.price);
      }, 0);

      $(salePriceEl).text(`$${totalPrice} + Free Gift`);
    }

    $("#bundle-popover").addClass("visible-form");
    $("#bundle-storage-container").addClass("visible-form");
  });

  $("#bundle-popover").on("click", () => {
    $("#bundle-container").removeClass("visible-form");
    $("#bundle-popover").removeClass("visible-form");
    $("#bundle-storage-container").removeClass("visible-form");
  });

  $(document).on("click", "a.product-item__aspect-ratio", (e) => {
    e.preventDefault();
    let parent = $(e.currentTarget).parent(".product-item__image-wrapper");
    let sibling = $(parent).siblings(".product-item__info");
    let childBtn = $(sibling).find(".button--bundle")[0];
    $(childBtn).click();
  });
};

const element = $("#bundle_anchor");

if (element.length != 0) {
  console.log(true, "FOUND");
  bundleBuilder();
}
